module.exports = __webpack_public_path__ + "static/media/arrow-r.7a3be0cd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resource/img/arrow-r.svg
// module id = 1239
// module chunks = 0